import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router';
import Breadcrumb from '../Layout/Breadcrumb';
import breadcrumbMap from './breadcrumbMap';
const Layout = ({ children }) => {
    const location = useLocation();
    const path = location.pathname;

    // Fallback to 'Dashboard' if no breadcrumb defined for the route
    const breadcrumbLabels = breadcrumbMap[path] || ['Dashboard'];

    // Build breadcrumb items with hrefs (link first item to "/", others to "#")
    const breadcrumbItems = breadcrumbLabels.map((label, index) => ({
        label,
        href: index === 0 ? '/' : '#',
    }));

    const title = breadcrumbLabels[breadcrumbLabels.length - 1];


    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(prev => !prev);
    };

    return (
        <div className="layout-wrapper active">
            
            <div className="app-layout">
                <div className="main-content">
                    <Sidebar isOpen={isSidebarOpen} onToggleSidebar={toggleSidebar} />
                    <div className="page-content">
                        <Header onToggleSidebar={toggleSidebar} />
                        <div className="minheight">
                            {/* <Breadcrumb title={title} items={breadcrumbItems} /> */}
                            {children}
                            </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
